module.exports = __webpack_public_path__ + "static/img/4haidao.c6c0df90.png";